const { debounce } = window.BAO.Utils

class CartItem extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['remove']
  }

  constructor () {
    super()

    this._loading = false
    this.sections = this.inPushCart
      ? window.BAO.sectionRenderer.pushCartSections
      : this.onCartPage
        ? window.BAO.sectionRenderer.cartSections
        : []
  }

  setupListeners () {
    super.setupListeners()

    this.removeLineItem = this.removeLineItem.bind(this)
    this.onQuantityChange = this.onQuantityChange.bind(this)
    this.changeLineItem = this.changeLineItem.bind(this)
    this.debouncedOnQuantityChange = debounce((event) => {
      this.onQuantityChange(event)
    }, 500)

    if (this.els?.remove?.exists) {
      this.listeners.add(this.els.remove.element, 'click', this.removeLineItem)
    }

    if (this.els?.variantselect?.exists) {
      this.listeners.add(
        this.els.variantselect.element,
        'change',
        this.changeLineItem,
      )
    }

    this.listeners.add(
      this,
      window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE,
      this.debouncedOnQuantityChange,
    )
  }

  async changeLineItem (event) {
    this.loading = true

    const id = event.target.value

    // Get current line item properties to preserve them
    let properties = {}
    try {
      const propertiesData = this.dataset.properties
      if (propertiesData) {
        const parsedProperties = JSON.parse(propertiesData)
        // Filter out properties that start with underscore (internal properties)
        properties = Object.fromEntries(
          Object.entries(parsedProperties).filter(
            ([key]) => !key.startsWith('_'),
          ),
        )
      }
    } catch (e) {
      console.warn('Failed to parse line item properties:', e)
    }

    // Remove the current line item
    await this.removeLineItem(null, true)

    // Add the new variant as a new line item with preserved properties
    const state = await window.BAO.Cart.addItem(
      { id, quantity: 1, properties },
      { sections: this.mappedSections },
    )

    this.loading = false

    if ('sections' in state) this.renderSections(state.sections)
  }

  /**
   * @param {MouseEvent} e
   * @param {boolean} silent
   *
   * @returns {Promise<void>}
   */
  async removeLineItem (e, silent = false) {
    if (e) e.preventDefault()

    this.loading = true

    const state = await window.BAO.Cart.removeItem(this.dataset.key, {
      sections: this.mappedSections,
      silent,
    })

    if (!silent) {
      this.loading = false

      if ('sections' in state) this.renderSections(state.sections)
    }
  }

  async onQuantityChange (e) {
    this.loading = true

    const state = await window.BAO.Cart.updateQuantity(
      this.dataset.key,
      e.detail.value,
      { sections: this.mappedSections },
    )

    this.loading = false

    if ('sections' in state) this.renderSections(state.sections)
  }

  get mappedSections () {
    return this.sections.map((s) => s.section)
  }

  get loading () {
    return this._loading
  }

  set loading (val) {
    this._loading = val

    if (this.inPushCart) {
      this.pushCart.loading = val
    }

    this.setAttribute('aria-busy', val.toString())
  }

  get pushCart () {
    return this.closest('push-cart')
  }

  get inPushCart () {
    return this.pushCart != null
  }

  get cart () {
    return this.closest('cart-items')
  }

  get onCartPage () {
    return this.cart != null
  }
}

if (!customElements.get('cart-item')) {
  customElements.define('cart-item', CartItem)
}
